module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/categoryIcons/special_offers/Bitmap3-45bec40e28adc3124f23e704d97108b2.png";